<template>
    <main class="consulation">
        <!-- <MasterTemplate v-if="data_master_template" :data="data_master_template"></MasterTemplate> -->
        <BannerButton v-if="data_banner" :bannerDataProp="data_banner"/>
        <section v-if="form_data"class="row sdj-consulation">
            <div class="" style="width: 100%;">
                                <!-- <h2 class="sdk-title-section agp-normal mb-20px">Contact Us</h2>  -->
                <Heading
                level="2"
                class="sdk-title-section agp-normal mb-20px"
                >
                Contact Us
                </Heading>
                <div class="main-contact display_flex">
                    <div class="consulation-thumb col-md-6 col-12">
                        <div v-if="consulation_description" class="consulation_description" v-html="consulation_description"></div>
                        <div class="inner-cons-thumb">
                            <img width="1000" height="1000" class="alt-lazy-img sb-cats__item-thumbnail img_detail" :data-original_src="form_data.thumbnail.full" :src="form_data.thumbnail.medium" alt="img"/>                  
                        </div>
                    </div>
                    <div class="form-contact col-md-6 col-12">
                        <CorporateForm v-if="form_data.form_select=='corporate'"></CorporateForm>
                        <ConsultationForm v-if="form_data && form_data.form_select=='consultation'" 
                        :data_title="form_data.form_title" :data_description="form_data.form_description" 
                        :data_key="form_data.site_key" 
                        :data_postId="form_data.post_id"
                        :data_store="form_data.store"
                        :data_type="type_of_consultation"
                        :data_page_title="page_title"
                        ></ConsultationForm>
                    </div>
                </div>
            </div>
        </section>
        <div v-if="master_template.length > 0 && form_data.form_select=='consultation'" class="master-template-sections text-center">
            <template v-for="(item, layout_id) in master_template" :key="layout_id">
                <ItemDoubleColumn v-if="item.layout == 'doubleCol'" :data="item.columns" ></ItemDoubleColumn>
                <SingleColumn v-if="item.layout == 'singleCol'" :data="item.columns"></SingleColumn>
                <BannerButton v-if="item.layout == 'banner'" :bannerDataProp="item.banner" />
                <ItemTripleColumn v-if="item.layout == 'tripleCol'" :data="item.columns"></ItemTripleColumn>
                <IconRow v-if="item.layout == 'iconsRow'" :data="item.icons"></IconRow>
                <ItemTextLeftRight v-if="item.layout == 'textLeft'" :data="item.columns"></ItemTextLeftRight>
                <ItemTextLeftRight v-if="item.layout == 'textRight'" :data="item.columns"></ItemTextLeftRight>
                <ItemDoubleColumnCta v-if="item.layout == 'doubleColCTA'" :data="item.doubleColCTA" ></ItemDoubleColumnCta>
                <ItemCrouselLayout v-if="item.layout == 'CarouselLayout'" :data="item.slides" :data_item="data_product_item"></ItemCrouselLayout>
                <Information v-if="item.layout == 'slider'" :data="item.items" ></Information>
            </template>
        </div>
        <CustomMadeGifts v-if="custom_made_gifs&&custom_made_gifs.heading" :data="custom_made_gifs" />
        <SpeakToUs v-if="stu_data && form_data.form_select=='consultation'" :data="stu_data"/>
        <FaqSection v-if="data_faq && form_data.form_select=='corporate'"
            :data="data_faq"
            :option_faqs="option_faqs.style"
         />
    </main>
</template>
    
    <script setup lang="ts">
    import { ref, onMounted, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    const { $ajax,$file } = useNuxtApp();
    import MasterTemplate from "../components/TemplateMaster/MasterTemplate.vue";
    import BannerButton from "~/components/Campaign/BannerButton.vue";
    import FaqSection from '../components/Product/SingleProduct/Faqs.vue';
    import SingleColumn from "../components/TemplateMaster/SingleColumn.vue";
    import ItemTextLeftRight from "../components/TemplateMaster/ItemTextLeftRight.vue";
    import ItemDoubleColumn from "../components/TemplateMaster/ItemDoubleColumn.vue";
    import ItemTripleColumn from "../components/TemplateMaster/ItemTripleColumn.vue";
    import ItemDoubleColumnCta from "../components/TemplateMaster/ItemDoubleColumnCta.vue";
    import FormMaster from "../components/TemplateMaster/FormMaster.vue";
    import ItemCrouselLayout from "../components/TemplateMaster/ItemCrouselLayout.vue";
    import IconRow from "../components/TemplateMaster/IconRow.vue";
    import Information from "~/components/Product/SingleProduct/Information.vue"
    import CorporateForm from "~/components/Corporate/Cooperateform-simple.vue"
    import SpeakToUs from "~/components/Corporate/SpeakToUs.vue"
    import Heading from '~/components/Heading.vue';
    import ConsultationForm from "~/components/Corporate/ConsultationForm.vue"
    import CustomMadeGifts from "~/components/Home/ShopMadeGif.vue";

    const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
    const userStore = useUserStore();
    const route = useRoute();
    const data_master_template = ref();
    const data_banner = ref([]);
    const master_template = ref([]);
    const data_faq = ref();
    const page_title = ref();
    const form_data = ref();
    const custom_made_gifs = ref();
    const stu_data = ref();
    const type_of_consultation = ref([]);
    const consulation_description = ref();
    interface IResponseData {
      success: boolean;
      data: any;
    }
    const option_faqs = ref({
        type : 1,
        style: {
            item: {
                background: '#fff',
                hoverBackground: '#fff',
                textColor: '#000',
                hoverColor: '#AD073D',
                fontSize: '20px'
            },
            icon: {
                background: '#000',
            },
            content: {
                background: '#fff',
                textColor: '#000',
                fontSize: '14px'
            }
        },
        
    })
  
  const fetchPosts = async () => {
      try {
          const { data: masterTemplate } = await useAsyncData(
              'consultation',
              async () => {
                // return $ajax.get(`/data/consultation/book-si-dian-jin-appointment-consultation.json`);
                // return $ajax.get(`/data/consultation/corporate-gifts-consultation.json`);
                return $file.get(`/consultation/consultation-consultation.json`, {
                    headers: {
                    Authorization: `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                    },
                });
              }
          )
  
          const response_Template = masterTemplate.value as IResponseData;
          if ( response_Template !== null && response_Template.success) {
            data_master_template.value = response_Template;
            form_data.value = response_Template.data.form;
            data_faq.value = response_Template.data?.faq;
            data_banner.value = response_Template.data.banner;
            master_template.value = response_Template.data?.layouts;
            stu_data.value = response_Template.data?.speak_to_us
            type_of_consultation.value= response_Template.data?.type_of_consultation
            page_title.value= response_Template.data?.page_title
            if (response_Template.data.custom_made_gifts) {
                custom_made_gifs.value = response_Template.data.custom_made_gifts;
            }
            if(response_Template.data.consulation_description){
                consulation_description.value = response_Template.data.consulation_description;
            }
          }
      } catch (e) {
          console.error(e);
      }
  };
  
    watch(() => route.params.slug, () => {
      fetchPosts();
    }, { immediate: true });
  
    onMounted(() => {
        altLazyIO();
        onMounted( ()=>{
            const routeslug = useRoute(); // Get the current route
            const pathSegments = routeslug.path.split('/').filter(segment => segment); 
            const pageType = 'contact-us'; 
            const hierachy1 = pathSegments[0] || 'n/a'; 
            const hierachy2 = pathSegments[1] || 'n/a'; 
            const hierachy3 = 'n/a';
            pushPageTypeToDataLayer(pageType, {
                hierachy1,
                hierachy2,
                hierachy3,
            });
        })
    })
</script>
<style lang="scss">
    @import "@/assets/scss/components/master-template/_master-template.scss";
    @import "@/assets/scss/components/consultation/_consultation.scss";
</style>